import { motion } from "framer-motion";
import { KeyRound, UserPlus, CloudUpload, Share2, Sprout } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const STEPS = [
    { icon: KeyRound,    step: "1", tk: "how1T", dk: "how1D" },
    { icon: UserPlus,    step: "2", tk: "how2T", dk: "how2D" },
    { icon: CloudUpload, step: "3", tk: "how3T", dk: "how3D"},
    { icon: Share2,      step: "4", tk: "how4T", dk: "how4D" },
    { icon: Sprout,      step: "5", tk: "how5T", dk: "how5D" },
];

const STEP_INITIAL = { opacity: 0, y: 24 };
const STEP_IN_VIEW = { opacity: 1, y: 0 };
const STEP_VIEWPORT = { once: true, margin: "-60px" };
const stepTransition = (i) => ({ duration: 0.5, delay: i * 0.1 });

export const HowItWorks = () => {
    const { t } = useLang();
    return (
        <section id="how-it-works" className="py-10 md:py-14 bg-[#F4F3FF]" data-testid="landing-how-it-works">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-2xl mx-auto">
                    <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#EF4444]">{t("howEyebrow")}</p>
                    <h2 className="mt-2 text-3xl md:text-4xl font-extrabold tracking-tight text-[#6D28D9]">
                        {t("howHeading")}
                    </h2>
                    <p className="mt-3 text-[14.5px] md:text-[16px] text-[#4B5563] leading-relaxed">
                        {t("howSub")}
                    </p>
                </div>

                <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 lg:gap-4">
                    {STEPS.map((s, i) => (
                        <motion.div
                            key={s.step}
                            initial={STEP_INITIAL}
                            whileInView={STEP_IN_VIEW}
                            viewport={STEP_VIEWPORT}
                            transition={stepTransition(i)}
                            className="relative bg-white rounded-2xl px-6 pt-9 pb-6 text-center border border-[#EDE9FE] shadow-[0_10px_30px_rgba(76,29,149,0.06)] hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(109,40,217,0.12)] transition-all"
                            data-testid={`how-it-works-step-${i + 1}`}
                        >
                            <span className="absolute top-3.5 left-1/2 -translate-x-1/2 inline-flex h-7 w-7 items-center justify-center rounded-full bg-[#F1F0FB] text-[12px] font-bold text-[#8B8B9E] select-none">
                                {s.step}
                            </span>
                            <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-[#FEE2E2] text-[#EF4444] mx-auto">
                                <s.icon className="h-6 w-6" />
                            </span>
                            <h3 className="mt-4 text-[16px] font-bold text-[#1F2937] leading-snug">{t(s.tk)}</h3>
                            <p className="mt-2 text-[13px] leading-relaxed text-[#4B5563] whitespace-pre-line">{t(s.dk)}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
